import { type Package, type Product } from '@hch/shared';
import {
  Badge,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '~/components/ui/primitives';
import { LoadingState, PageHeader } from '~/components/shared/states';
import { useProducts, usePackages } from '~/lib/queries';
import { formatDuration, formatPrice } from '~/lib/utils';

export function AdminCatalogPage() {
  const { data: packages, isLoading: loadingPackages } = usePackages();
  const { data: products, isLoading: loadingProducts } = useProducts();

  return (
    <div className="app-page">
      <PageHeader
        title="Catalogue"
        description="Forfaits et produits additionnels. Les tarifs des interventions passees ne sont jamais modifies."
      />

      <Tabs defaultValue="packages">
        <TabsList>
          <TabsTrigger value="packages">Forfaits</TabsTrigger>
          <TabsTrigger value="products">Produits</TabsTrigger>
        </TabsList>

        <TabsContent value="packages" className="pt-4">
          {loadingPackages ? <LoadingState /> : null}
          <Card className="py-0">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Forfait</TableHead>
                  <TableHead>Operation</TableHead>
                  <TableHead>Duree</TableHead>
                  <TableHead>Cycle</TableHead>
                  <TableHead className="text-right">Prix</TableHead>
                  <TableHead>Statut</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {packages?.map((item: Package) => (
                  <TableRow key={item.id}>
                    <TableCell className="font-medium">{item.name}</TableCell>
                    <TableCell className="text-muted-foreground">
                      {item.serviceType?.name}
                    </TableCell>
                    <TableCell>{formatDuration(item.durationMin)}</TableCell>
                    <TableCell>
                      <Badge variant="secondary">
                        {item.cycleType === 'EBIKE'
                          ? 'VAE'
                          : item.cycleType === 'BIKE'
                            ? 'Musculaire'
                            : 'Tous'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right font-medium tabular-nums">
                      {formatPrice(item.price)}
                    </TableCell>
                    <TableCell>
                      <Badge variant={item.isActive ? 'success' : 'outline'}>
                        {item.isActive ? 'Actif' : 'Inactif'}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Card>
        </TabsContent>

        <TabsContent value="products" className="pt-4">
          {loadingProducts ? <LoadingState /> : null}
          <Card className="py-0">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Produit</TableHead>
                  <TableHead>Categorie</TableHead>
                  <TableHead>Reference</TableHead>
                  <TableHead className="text-right">Prix</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {products?.map((product: Product) => (
                  <TableRow key={product.id}>
                    <TableCell className="font-medium">{product.name}</TableCell>
                    <TableCell>
                      <Badge variant="secondary">{product.category}</Badge>
                    </TableCell>
                    <TableCell className="font-mono text-xs text-muted-foreground">
                      {product.reference ?? '—'}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">
                      {formatPrice(product.price)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}

// Societe
